import classNames from 'classnames'
import React, { Fragment, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import classes from './expenses.module.css'

import allActions from '../actions'
import ExpenseChart from '../components/ExpenseChart'
import ExpenseTag from '../components/ExpenseTag'
import SpendDetails from '../components/SpendDetails'
import ExpenseFilter from '../components/ExpenseFilter'

function ExpensesPage() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(allActions.getAsyncData())
  }, [ ])

  const expensesData = useSelector((state) => state.asyncExpensesReducer)?.expensesData

  if (!expensesData) return <p>Loading..</p>

  const { cardBalance, expenses, spendChartData, chartMetaData, balanceBreakup, month } = expensesData

  return (
    <Fragment>
      <div className={classes.headerWrapper}>
        <div className={classNames(classes.container, classes.container_stretched, classes.container_center)}>
          <p className={classes.header}>
            Expenses
          </p>
          <img src="/icons/logo.png" alt="logo" className={classes.logo} />
        </div>
        <div className={classNames(classes.container, classes.container_stretched, classes.container_center)}>
          <div className={classes.balance}>
            <p>Card Balance</p>
            <h2>{`$${cardBalance.toLocaleString()}`}</h2>
          </div>
          <div className={classes.expensesWrapper}>
            <ExpenseTag type="earns" value={balanceBreakup.earns} />
            <ExpenseTag type="spends" value={balanceBreakup.spends} />
          </div>
        </div>
      </div>
      <ExpenseFilter months={month} />
      <ExpenseChart data={spendChartData} metadata={chartMetaData} />
      <SpendDetails data={expenses} />
    </Fragment>
  )
}

export default ExpensesPage
